import { NavItem } from '@data-access/shared';
import { SubmissionResponse } from '../types';

type TRouteFeatures = {
  /** If true, will allow 'appeals' route */
  appeals?: boolean;
};

/** Determines if the route should be included */
const filterRoutesByFeatures = (item: NavItem, features?: TRouteFeatures) => {
  switch (item.id) {
    case 'appeals': {
      return features && features.appeals === true;
    }
    default:
      return true;
  }
};

export function handleMappingRoutes(
  routes: Set<NavItem>,
  isInternal: boolean,
  submission: SubmissionResponse,
  features?: TRouteFeatures,
) {
  const navItems = [...routes];

  const filteredByFeature = navItems.filter((item) =>
    filterRoutesByFeatures(item, features),
  );

  return new Set(
    filteredByFeature.map((item) => {
      // Map 'details' tab if user has permission to view submission details
      if (
        submission.permissions?.can_view_submission_details &&
        item.id === 'details'
      ) {
        return { ...item, label: 'Submission Details', path: 'details' };
      }
      // Map 'documents' tab if user has permission to view submission documents
      if (
        submission.permissions?.can_view_submission_documents &&
        item.id === 'documents'
      ) {
        return { ...item, label: 'Submission Documents', path: 'documents' };
      }
      // Map 'contacts' tab for internal users
      if (
        (isInternal || (!isInternal && submission.current_stage !== 'draft')) &&
        item.id === 'contacts'
      ) {
        return { ...item, label: 'Contacts', path: 'contacts' };
      }
      return item;
    }),
  );
}
